import React from 'react';
import { BlockStack, InlineGrid, Text, ProgressBar, InlineStack } from '@shopify/polaris';
import 'media/css/revenue.scss';

interface RevenueItemProps {
  tone?: 'success' | 'warning' | 'normal';
  title: string;
  value: string | number;
  icon: React.ReactNode;
  subInfo?: React.ReactNode;
  progress?: number;
  footer?: string;
  loading?: boolean;
}

const RevenueItem: React.FC<RevenueItemProps> = React.memo(({ tone = 'normal', title, value, icon, subInfo, progress, footer }) => {
  return (
    <div className={`revenue_item  item_${tone}`}>
      <BlockStack gap="300">
        <InlineStack align="space-between" blockAlign="center">
          <Text as="h2" fontWeight="bold">
            {title}
          </Text>
          {icon}
        </InlineStack>
        <span style={{ fontSize: '1.25rem', fontWeight: 'bold' }}>{value}</span>

        <div style={{ minHeight: '26px', display: 'flex', flexDirection: 'column', gap: '4px' }}>
          {progress !== undefined && (
            <BlockStack gap="100">
              <ProgressBar progress={progress} size="small" />
              {footer && <Text as="p">{footer}</Text>}
            </BlockStack>
          )}
          {subInfo && (
            <Text as="h3" fontWeight="bold">
              {subInfo}
            </Text>
          )}
        </div>
      </BlockStack>
    </div>
  );
});

export default RevenueItem;

